import infopageTemplate from './infopage.html';

var config = function ($stateProvider) {
    
    /* Create the logout state and assign the template and controller. */
    $stateProvider
		.state('infopage', {
			url: '/info',
			template: infopageTemplate,
			controller: 'infopageController',
			controllerAs: 'infopageController'
		});
}

export default config;



// WEBPACK FOOTER //
// ./src/infopage/infopage.route.js